import ApiService from "../api";

export default class BPService extends ApiService {

    constructor() {
        super("/api/bp");
    }

    relatorioLista(values = {}, ano, pageable = {}, filtro = "", comValorTotal = false, comValorRealizado = false,) {
        const {
            logistico = [],
            centroCusto = [],
            contaContabil = [],
            filial = [],
            tipo = [],
            responsavel = []
        } = values;

        const {
            page = 0,
            size = 10,
        } = pageable;

        const params = new URLSearchParams();

        if (ano) params.append("ano", [ano].join(","));
        if (centroCusto.length) params.append("centroCusto", centroCusto.join(","));
        if (contaContabil.length) params.append("contaContabil", contaContabil.join(","));
        if (logistico.length) params.append("logistico", logistico.join(","));
        if (filial.length) params.append("filial", filial.join(","));
        if (tipo.length) params.append("tipo", tipo.join(","));
        if (responsavel.length) params.append("responsavel", responsavel.join(","));
        if (filtro) params.append("search", filtro);

        params.append("comValorTotal", comValorTotal);
        params.append("comValorRealizado", comValorRealizado);
        params.append("page", page);
        params.append("size", size);

        return this.get(`/relatorio-em-lista?${params}`);
    }

    relatorioPaginado(values = {}, ano, pageable = {}, filtro = "", comValorTotal = false, comValorRealizado = false,) {
        const {
            logistico = [],
            centroCusto = [],
            contaContabil = [],
            filial = [],
            tipo = [],
            responsavel = []
        } = values;

        const {
            page = 0,
            size = 10,
        } = pageable;

        const params = new URLSearchParams();

        if (ano) params.append("ano", [ano].join(","));
        if (centroCusto.length) params.append("centroCusto", centroCusto.join(","));
        if (contaContabil.length) params.append("contaContabil", contaContabil.join(","));
        if (logistico.length) params.append("logistico", logistico.join(","));
        if (filial.length) params.append("filial", filial.join(","));
        if (tipo.length) params.append("tipo", tipo.join(","));
        if (responsavel.length) params.append("responsavel", responsavel.join(","));
        if (filtro) params.append("search", filtro);

        params.append("comValorTotal", comValorTotal);
        params.append("comValorRealizado", comValorRealizado);
        params.append("page", page);
        params.append("size", size);

        return this.get(`/relatorio-paginado?${params}`);
    }

    buscarLogBP(id) {
        return this.get(`/log/${id}`)
    }

    listarTodos(ano, nomeUsuario) {
        return this.get(`/ano/${ano}/email/${nomeUsuario}`);
    }

    listarMeuBP(ano, nomeUsuario) {
        return this.get(`/ano/${ano}/email/${nomeUsuario}/meu-bp`);
    }

    listarPaginado(filtros = {}, pageable = {}) {
        const {
            ano,
            centroCusto = [],
            contaContabil = [],
            filial = [],
            responsavel = [],
            tipo = [],
            grupo = [],
            status = []
        } = filtros;

        const {
            page = 0,
            size = 10,
            sortKey = "",
            sortDirection = "",
        } = pageable;

        const params = new URLSearchParams();
        params.append("ano", ano ?? 2026);

        // Converte arrays para string separada por vírgula
        if (centroCusto.length) params.append("centroCusto", centroCusto.join(","));
        if (contaContabil.length) params.append("contaContabil", contaContabil.join(","));
        if (filial.length) params.append("filial", filial.join(","));
        if (responsavel.length) params.append("responsavel", responsavel.join(","));
        if (tipo.length) params.append("tipo", tipo.join(","));
        if (grupo.length) params.append("grupo", grupo.join(","));
        if (status.length) params.append("status", status.join(","));

        params.append("page", page);
        params.append("size", size);

        if (sortKey && sortDirection) {
            params.append("sort", `${sortKey},${sortDirection}`);
        }


        const url = `/lista-paginada?${params.toString()}`;
        return this.get(url);
    }

    listarMinhasContas(filtros = {}, pageable = {}, email) {
        const {
            centroCusto = [],
            contaContabil = [],
            filial = [],
            tipo = [],
            modo = [],
            status = [],
            usuarioCompartilhado = [],
        } = filtros;

        const {
            page = 0,
            size = 10,
            sortKey = "",
            sortDirection = "",
        } = pageable;

        const params = new URLSearchParams();

        // Converte arrays para string separada por vírgula
        if (centroCusto.length) params.append("centroCusto", centroCusto.join(","));
        if (contaContabil.length) params.append("contaContabil", contaContabil.join(","));
        if (filial.length) params.append("filial", filial.join(","));
        if (tipo.length) params.append("tipo", tipo.join(","));
        if (modo.length) params.append("modo", modo.join(","));
        if (status.length) params.append("status", status.join(","));
        if (usuarioCompartilhado.length) params.append("usuarioCompartilhado", usuarioCompartilhado.join(","));

        params.append("page", page);
        params.append("size", size);

        if (sortKey && sortDirection) {
            params.append("sort", `${sortKey},${sortDirection}`);
        }

        const url = `/lista-paginada/usuario/${email}?${params.toString()}`;
        return this.get(url);
    }

    relatorioMeuBP(filtros = {}) {
        const {
            centroCusto = [],
            contaContabil = [],
            filial = [],
            responsavel = [],
            tipo = [],
            ano = 2026
        } = filtros;

        const params = new URLSearchParams();

        // Converte arrays para string separada por vírgula
        if (centroCusto.length) params.append("centroCusto", centroCusto.join(","));
        if (contaContabil.length) params.append("contaContabil", contaContabil.join(","));
        if (filial.length) params.append("filial", filial.join(","));
        if (responsavel.length) params.append("responsavel", responsavel.join(","));
        if (tipo.length) params.append("tipo", tipo.join(","));
        params.append('ano', ano);

        const url = `/relatorio-meu-bp?${params.toString()}`;
        return this.get(url);
    }

    listarBPCompartilhados(ano, nomeUsuario) {
        return this.get(`/compartilhados/ano/${ano}/email/${nomeUsuario}`);
    }

    resumoOrcado(ano) {
        return this.get(`/resumo-orcado/ano/${ano}`);
    }

    listarTodosPorAno(ano) {
        return this.get(`/ano/${ano}`);
    }

    marcarComoOrcado(usuarioId, ano) {
        return this.put(`/orcamento/marcar/${usuarioId}/${ano}`);
    }

    desmarcarComoOrcado(usuarioId, ano) {
        return this.put(`/orcamento/desmarcar/${usuarioId}/${ano}`);
    }

    compartilhar(ids, usuarioId) {
        return this.put("/compartilhar", { ids, usuarioId });
    }

    // Descompartilhar itens
    descompartilhar(ids) {
        return this.put("/descompartilhar", ids);
    }

    buscarPorId(id) {
        return this.get(`/${id}`);
    }

    criar(data) {
        return this.post("", data);
    }

    atualizar(id, data) {
        return this.put(`/${id}`, data);
    }

    atualizarValoresMensais(data) {
        return this.put(`/valores`, data);
    }

    atualizarValoresMensaisAdmin(data) {
        return this.put(`/valores/admin`, data);
    }

    desmarcaContaOrcada(id) {
        return this.put(`/${id}/desmarcar-conta`);
    }

    atualizarResponsavelEGrupo(data) {
        return this.put(`/atualizar`, data);
    }

    exportExcelPorAnoEusuario(ano, nomeUsuario) {
        return this.getFile(`/exportar/ano/${ano}/email/${nomeUsuario}`);
    }

    exportExcelPorAno(filtros = {}) {
        const {
            ano,
            centroCusto = [],
            contaContabil = [],
            filial = [],
            responsavel = [],
            tipo = [],
            email = ""
        } = filtros;


        const params = new URLSearchParams();
        params.append("ano", ano ?? 2026);

        // Converte arrays para string separada por vírgula
        if (centroCusto.length) params.append("centroCusto", centroCusto.join(","));
        if (contaContabil.length) params.append("contaContabil", contaContabil.join(","));
        if (filial.length) params.append("filial", filial.join(","));
        if (responsavel.length) params.append("responsavel", responsavel.join(","));
        if (tipo.length) params.append("tipo", tipo.join(","));
        if (email) params.append("email", email);

        return this.getFile(`/exportar-excel?${params.toString()}`);
    }

    importarExcel(file, usuarioId) {
        return this.post(`/importar/usuario/${usuarioId}`, file)
    }

    excluir(id) {
        return this.delete(`/${id}`);
    }

    excluirEmLista(ids) {
        return this.delete(`/delete-all?ids=${ids}`);
    }

    atualizarResponsaveis(ids, responsavelId) {
        return this.put(`/atualizar-responsaveis?ids=${ids}&responsavelId=${responsavelId}`);
    }

    relatorioSimplificado(values, distribuidorLogistico, ano) {
        var params = "";
        Object.entries(values).forEach(([key, value]) => {
            if (value) {
                params += key + "=" + value + "&"
            };
        });
        params += "logistico=" + distribuidorLogistico;
        return this.get(`/relatorio?ano=${ano}&${params}`);
    }

    relatorioTotais(values) {
        const {
            ano = [],
            mes = [],
            logistico = [],
            centroCusto = [],
            contaContabil = [],
            filial = [],
            tipo = [],
            responsavel = [],
        } = values;

        const params = new URLSearchParams();

        if (ano) params.append("ano", ano.join(","));
        if (mes) params.append("mes", mes.join(","));
        if (centroCusto.length) params.append("centroCusto", centroCusto.join(","));
        if (contaContabil.length) params.append("contaContabil", contaContabil.join(","));
        if (logistico.length) params.append("logistico", logistico.join(","));
        if (filial.length) params.append("filial", filial.join(","));
        if (tipo.length) params.append("tipo", tipo.join(","));
        if (responsavel.length) params.append("responsavel", responsavel.join(","));

        return this.get(`/relatorio/totais?${params}`);
    }

    relatorioKpi(values) {
        const {
            ano = [],
            mes = [],
            logistico = [],
            centroCusto = [],
            contaContabil = [],
            filial = [],
            tipo = [],
            responsavel = [],
        } = values;

        const params = new URLSearchParams();

        if (ano) params.append("ano", ano.join(","));
        if (mes) params.append("mes", mes.join(","));
        if (centroCusto.length) params.append("centroCusto", centroCusto.join(","));
        if (contaContabil.length) params.append("contaContabil", contaContabil.join(","));
        if (logistico.length) params.append("logistico", logistico.join(","));
        if (filial.length) params.append("filial", filial.join(","));
        if (tipo.length) params.append("tipo", tipo.join(","));
        if (responsavel.length) params.append("responsavel", responsavel.join(","));

        return this.get(`/relatorio/kpi?${params}`);
    }

    relatorioVolume(values) {
        const {
            ano = [],
            mes = [],
            logistico = [],
            centroCusto = [],
            contaContabil = [],
            filial = [],
            tipo = [],
            responsavel = [],
        } = values;

        const params = new URLSearchParams();
        if (ano) params.append("ano", ano.join(","));
        if (mes) params.append("mes", mes.join(","));
        if (centroCusto.length) params.append("centroCusto", centroCusto.join(","));
        if (contaContabil.length) params.append("contaContabil", contaContabil.join(","));
        if (logistico.length) params.append("logistico", logistico.join(","));
        if (filial.length) params.append("filial", filial.join(","));
        if (tipo.length) params.append("tipo", tipo.join(","));
        if (responsavel.length) params.append("responsavel", responsavel.join(","));

        return this.get(`/relatorio-volume?${params}`);
    }

    exportDashboardExcel(values) {
        const {
            ano = [],
            logistico = [],
            centroCusto = [],
            contaContabil = [],
            filial = [],
            tipo = [],
            responsavel = [],
        } = values;

        const params = new URLSearchParams();

        if (ano) params.append("ano", ano.join(","));
        if (centroCusto.length) params.append("centroCusto", centroCusto.join(","));
        if (contaContabil.length) params.append("contaContabil", contaContabil.join(","));
        if (logistico.length) params.append("logistico", logistico.join(","));
        if (filial.length) params.append("filial", filial.join(","));
        if (tipo.length) params.append("tipo", tipo.join(","));
        if (responsavel.length) params.append("responsavel", responsavel.join(","));

        return this.get(`/relatorio/excel?${params}`);

    }

    relatorioDiario(filtros = {}, ano, mes) {
        const {
            logistico = [],
            centroCusto = [],
            contaContabil = [],
            filial = [],
            tipo = [],
            responsavel = [],
        } = filtros;

        const params = new URLSearchParams();

        if (ano) params.append("ano", ano);
        if (centroCusto.length) params.append("centroCusto", centroCusto.join(","));
        if (contaContabil.length) params.append("contaContabil", contaContabil.join(","));
        if (logistico.length) params.append("logistico", logistico.join(","));
        if (filial.length) params.append("filial", filial.join(","));
        if (tipo.length) params.append("tipo", tipo.join(","));
        if (responsavel.length) params.append("responsavel", responsavel.join(","));

        return this.get(`/relatorio-diario?&mes=${mes}&${params}`);
    }

    filtrosBP(values, ano) {
        return this.get(`/filtros?ano=${ano}`);
    }

    filtros() {
        return this.get(`/filtros-todos`);
    }

    filtrosPorUsuario(email) {
        return this.get(`/filtros-todos/${email}`);
    }

    buscaDataFechamento() {
        return this.get(`/data-fechamento`);
    }

    ajustaDataFechamento(data) {
        return this.post(`/data-fechamento`, data);
    }

    log() {
        return this.post(`/log`);
    }

    comparativo() {
        return this.get(`/comparativo`);
    }

    listarParaFluig(codigoFilial) {
        return this.get(`/fluig?codigoFilial=${codigoFilial}`);
    }
}
